import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityStateType, ItemState, ItemStateBody } from '@compiere-ws/models/apiz-domains';
import { CompiereDataFieldType } from '@compiere-ws/models/compiere-data-json';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FieldStateService {
  #http = inject(HttpClient);

  getEntityStateUrl(entity: string, id: number): string {
    return `${environment.config.backend.ws.url}/ui/${entity}/${id}/state`;
  }

  getEntityState<T extends ItemState | undefined>({
    fieldType,
    id,
    ...request
  }: ItemStateBody & { fieldType: CompiereDataFieldType; id: number }): Observable<T> {
    const entityId = id;
    const entity = ((): EntityStateType => {
      if (fieldType === CompiereDataFieldType.FIELD) {
        return EntityStateType.FIELD;
      }

      if (fieldType === CompiereDataFieldType.FORM_ITEM) {
        return EntityStateType.FORM_DETAIL_ITEM;
      }

      if (fieldType === CompiereDataFieldType.PROCESS_PARA) {
        return EntityStateType.PROCESS_PARAM;
      }
    })();

    return this.#http.post<T>(this.getEntityStateUrl(entity, entityId), request);
  }

  getTabState<T extends ItemState | undefined>(recordId: number, request: ItemStateBody): Observable<T> {
    return this.#http.post<T>(this.getEntityStateUrl(EntityStateType.TAB, recordId), request);
  }

  getFieldState<T extends ItemState | undefined>(recordId: number, request: ItemStateBody): Observable<T> {
    return this.#http.post<T>(this.getEntityStateUrl(EntityStateType.FIELD, recordId), request);
  }

  getProcessParamState<T extends ItemState | undefined>(recordId: number, request: ItemStateBody): Observable<T> {
    return this.#http.post<T>(this.getEntityStateUrl(EntityStateType.PROCESS_PARAM, recordId), request);
  }

  getFormDetailState<T extends ItemState | undefined>(recordId: number, request: ItemStateBody): Observable<T> {
    return this.#http.post<T>(this.getEntityStateUrl(EntityStateType.FORM_DETAIL_ITEM, recordId), request);
  }
}
